import { FC, useState } from "react";
import "./payment.scss";
import { useDispatch, useSelector } from "react-redux";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import { createShop, setNewShopDetails } from "../../shopSlices";
import { PaymentElement } from "@stripe/react-stripe-js";
import { Button } from "primereact/button";

interface PaymentProps {
    setStep: Function;
    setSelectedPlan: Function;
    selectedPlan: string;
}
const Payment:FC<PaymentProps> = ({setStep, selectedPlan, setSelectedPlan}) => {
    const dispatch: Function = useDispatch();
    const user = useSelector((state: any) => state.auth.user);
    const newShopDetails = useSelector((state: any) => state.shop.newShopDetails);
    const subscriptionId = useSelector((state: any) => state.user.subscriptionId);
    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);
    const [message, setMessage] = useState(null);
    
    const sendCreateShop = () => {
        dispatch(createShop(newShopDetails.name, newShopDetails.address,user.sub, subscriptionId, selectedPlan))
        dispatch(setNewShopDetails({name:'', address:''}))
        setSelectedPlan(null)
        setStep(1)
      }

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!stripe || !elements) {
          // Stripe.js has not yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          return;
        }
    
        setIsProcessing(true);
        const { error, paymentIntent } = await stripe.confirmPayment({
          elements,
          confirmParams: {
            receipt_email: 'ilan.balouka@gmail.com'
          },
          redirect:'if_required'
        });
        if(paymentIntent && paymentIntent.status == "succeeded"){
          sendCreateShop()
          setMessage(null)
          setStep(1)
        }
  
        if (error) {
          setMessage("Check your card details and try again");
        }
    
        setIsProcessing(false);
      };
    const handleCancelBtn = ()=> {
        setSelectedPlan(null)
        setStep(1)
    }
    return (
        <div className={`payment`}>
            <PaymentElement id="payment-element" />
            <div className="new-shop-popup__footer" style={{marginTop:'16px'}}>
            <Button onClick={() => handleCancelBtn()} iconPos='right' label={'Cancel'} className="new-shop-popup__footer__cancel-button" />
            <Button onClick={(e) => handleSubmit(e)} iconPos='right' disabled={!newShopDetails.name || !newShopDetails.address } label={'Confirm'} className="new-shop-popup__footer__confirm-button" />
          </div>
        </div>
    );
};

export default Payment;
